import React, {FC, ReactElement} from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {strings} from '@constants';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'inline-block',
        borderColor: theme.palette.text.secondary,
        borderStyle: 'solid',
        borderWidth: theme.typography.pxToRem(1),
        lineHeight: 1,
        padding: theme.spacing(0.3),
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
    }
}));

interface SourceLabelProps {
    className?: string,
    source: string
}

const SourceLabel: FC<SourceLabelProps> = ({className = '', source}): ReactElement => {
    const classes = useStyles();

    return (
        <Typography
            component="span"
            className={`${className} ${classes.root}`}
            color="textPrimary">
            {strings.source(source)}
        </Typography>
    );
};

export default SourceLabel;
